/* src/assets/svg/MasterCardLogo.jsx */
import * as React from "react";

/**
 * MasterCard 2016 logo
 * @param {object} props 
 */
const MasterCardLogo = (props) => (
  <svg
    viewBox="0 0 999.2 776"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/*​ orange rectangle behind the overlap (left-hand colour) */}
    <rect x="364" y="66.1" width="270.4" height="485.8" fill="#FF5A00" />

    {/* left circle (Master) */}
    <path
      fill="#EB001B"
      d="M382 309c0-98.7 46.4-186.3 117.6-242.9C447.2 24.9 381.1 0 309 0 138.2 0 0 138.2 0 309s138.2 309 309 309c72.1 0 138.2-24.9 190.6-66.1C428.3 496.1 382 407.7 382 309z"
    />

    {/* right circle (Card) */}
    <path
      fill="#F79E1B"
      d="M999.2 309c0 170.8-138.2 309-309 309-72.1 0-138.2-24.9-190.6-66.1 72.1-56.7 117.6-144.2 117.6-242.9S570.8 122.7 499.6 66.1C551.9 24.9 618 0 690.1 0c170.9 0 309.1 139.1 309.1 309z"
    />
  </svg>
);

export default MasterCardLogo;
